import { useDispatch, useSelector } from "react-redux";
import {
  setStats,
  clearStats,
} from "../../store/slices/dashboard/customerDashboardSlice";
import { AppDispatch, RootState } from "../../store/store";
import CustomerDashboardService from "../../services/dashboard/CustomerDashboardService";
import useApiErrorHandler from "../useApiErrorHandler";
// import useLoading from "../useLoading";

export const useCustomerDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();
  // const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  // ✅ Estados desde Redux
  const { stats } = useSelector((state: RootState) => state.customerDashboard);

  /**
   * 📊 Cargar estadísticas del dashboard de clientes
   */
  const fetchStats = async () => {
    try {
      // showLoadingIndicator();

      const response = await CustomerDashboardService.getStats();
      if (response?.statusCode === 200) {
        const { data } = response;
        dispatch(setStats(data));
        // 🚫 Ya no abrimos ningún modal aquí
      }
    } catch (error: any) {
      handle(error);
    } finally {
      // hideLoadingIndicator();
    }
  };

  /**
   * 🔄 Limpiar estadísticas (si necesitas resetear en algún momento)
   */
  const resetStats = () => {
    dispatch(clearStats());
  };

  return {
    // Estados
    stats,

    // Métodos
    fetchStats,
    resetStats,
  };
};

export default useCustomerDashboard;
